import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTerminalNavigate } from '~/hooks/use-terminal-navigate/useTerminalNavigate';
import { appPaths } from '~/routes/app-paths';
import { WatchlistData } from '~/stores/use-chat/assistant-response.type';

import { MultipleEntityMatches } from '../multiple-entity-matches/MultipleEntityMatches';
import * as S from '../WatchlistMessage.styles';

export interface PartialMessageProps {
  data: Extract<WatchlistData, { status: 'partial' }>;
  name: string;
  action: string;
}

export const PartialMessage = ({ data, name, action }: PartialMessageProps) => {
  const { t } = useTranslation(['intel', 'watchlistManager']);
  const navigateTerminal = useTerminalNavigate();

  return (
    <div data-testid="partial">
      {data.issues.map(issue => {
        const queries =
          'items' in issue
            ? issue.items?.map(o => ('queries' in o ? o?.queries[0] : ''))
            : '';

        if (issue.code === 'multiple-entity-matches') {
          return (
            <MultipleEntityMatches
              key={issue.code}
              action={action}
              items={issue.items}
              info={data.info}
            />
          );
        }
        return (
          <S.FlexContainer key={issue.code}>
            <S.ReplyMessage>
              {/* i18next-extract-disable-next-line */}
              {t(`intel:watchlist.partial.${action}.${issue.code}`, {
                queries,
                name,
              })}
            </S.ReplyMessage>
            {issue.code === 'no-entity-matches' && (
              <S.StyledButton
                data-testid="partial-no-entity-matches"
                label={t(
                  'intel:watchlist.partial.remove-entities.view-watchlist'
                )}
                variant="secondary"
                onClick={() =>
                  navigateTerminal({
                    to: {
                      pathname: appPaths.watchlistManager,
                      search: `?id=${data.info.id}`,
                    },
                    crumb: { label: t('watchlistManager:title') },
                  })
                }
              />
            )}
          </S.FlexContainer>
        );
      })}
    </div>
  );
};
